/*  MUI  */
import { Box, Typography } from '@mui/material';

/*  Shared  */
import CustomScript from 'application/Shared/Components/CustomScript/Containers/CustomScript';

/* Hooks */
import { useUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { IntegrationWrapper } from './Components/IntegrationWrapper';

let appVersion = '1.26.0';
if (process.env.REACT_APP_VERSION) {
    appVersion = process.env.REACT_APP_VERSION;
}

const deploymentSteps = ({
    onboarding,
    t
}: {
    onboarding: boolean;
    t: (key: string) => string;
}) => [
    {
        component: (
            <Typography variant="h4">
                {t('Integrations.setup_process')}
            </Typography>
        ),
        step: false
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.acronis.step1')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.acronis.step2')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.acronis.step3')
                }}
            />
        ),
        step: true
    },
    {
        component: <Typography>{t('Integrations.set_the_name')}</Typography>,
        copyValue:
            // @ts-expect-error component is not typed
            t('Integrations.asm_version', { appVersion }),
        step: false
    },
    {
        component: t('Integrations.set_the_description'),

        copyValue: t(
            'Integrations.acronis.set_the_description',
            // @ts-expect-error component is not typed
            { date: new Date() }
        )
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.set_the_status')
                }}
            />
        )
    },
    {
        component: (
            <Box width="100%">
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.acronis.selectClient')
                    }}
                />
                <CustomScript forAcronis onboarding={onboarding} />
            </Box>
        )
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.acronis.step4')
                }}
            />
        ),
        step: true
    },
    {
        component: (
            <Box>
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.acronis.step5')
                    }}
                />
                <ul>
                    <li>
                        <Typography
                            dangerouslySetInnerHTML={{
                                __html: t('Integrations.acronis.step5.1')
                            }}
                        />
                    </li>
                    <li>{t('Integrations.acronis.step5.2')}</li>
                    <li>
                        <Typography
                            dangerouslySetInnerHTML={{
                                __html: t('Integrations.acronis.step5.3')
                            }}
                        />
                    </li>
                    <ul>
                        <li>
                            {' '}
                            <Typography
                                dangerouslySetInnerHTML={{
                                    __html: t('Integrations.acronis.step5.3.1')
                                }}
                            />
                        </li>
                        <li>
                            {' '}
                            <Typography
                                dangerouslySetInnerHTML={{
                                    __html: t('Integrations.acronis.step5.3.2')
                                }}
                            />
                        </li>
                        <li>
                            {' '}
                            <Typography
                                dangerouslySetInnerHTML={{
                                    __html: t('Integrations.acronis.step5.3.3')
                                }}
                            />
                        </li>
                    </ul>
                    <li>
                        {' '}
                        <Typography
                            dangerouslySetInnerHTML={{
                                __html: t('Integrations.acronis.step5.4')
                            }}
                        />
                    </li>
                </ul>
            </Box>
        ),
        step: true
    },
    {
        component: (
            <Box>
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.acronis.step6')
                    }}
                />
                <ul>
                    <li>{t('Integrations.acronis.step6.1')}</li>
                </ul>
            </Box>
        ),
        step: true
    }
];

export const Acronis = ({ onboarding = false }) => {
    const { t } = useTranslation();
    const userTheme = useUserTheme();

    return (
        <IntegrationWrapper
            hasToken
            deploymentSteps={deploymentSteps({ onboarding, t })}
            headerTitle={t('Integrations.acronis.title')}
            img={`/images/${userTheme}/integrations/acronis.png`}
            imgWidth="200px"
            onboarding={onboarding}
        />
    );
};
